import messagePopupManager from "../../util/messagePopupManager";

export default {

    removeFromDeckList(deck, context){
        let deckList = context.getters.getDeckList;
        deckList = deckList.filter((iteratorDeck)=>{
            return iteratorDeck.id !== deck.id;
        })

        return deckList;
    },
    removeFromRoomList(room, context){
        let roomList = context.getters.getRoomList;
        roomList = roomList.filter((iteratorRoom)=>{
            return iteratorRoom.id !== room.id;
        })

        return roomList;
    },
    checkDeleteResponseCodeAndShowPopup(code){
        if(code === 460) {
            messagePopupManager.showError("error", "Entity is used somewhere and cant be deleted.");
        }else{
            messagePopupManager.showError();
        }
    },
    checkCreateResponseCodeAndShowPopup(code){
        if(code === 460) {
            messagePopupManager.showError("error", "Entity is used somewhere and cant be created.");
        }else{
            messagePopupManager.showError();
        }
    }
}